export default __webpack_public_path__ + "static/media/Major Rune Stone of Quilled Darts (V).e2047240.jpg";